import { useState } from "react";
import { isMobile } from "react-device-detect";
import Sheet from 'react-modal-sheet';

import computer_img from '../../assets/images/computer.svg'
import computer_pc_img from '../../assets/images/computer-pc.svg'
import './DesktopSheet.css'
import { TitleH2 } from "../TitleH2";
import { Text } from "../Text";
import { useSelector } from "react-redux";
import { selectUserData } from "../../features/User/userSlice";
import { Button } from "../Button";
import { toast } from "react-toastify";
import { selectAppInfo } from "../../services/utils/appInfoSlice";
import { WEB_PATH } from "../../config/constants";
import { selectTranslations } from "../../services/i18n/i18nSlice";

export default function DesktopSheet () {

    const [isOpen,setIsOpen] = useState(false)
    const userInfo = useSelector(selectUserData)

    const appInfo = useSelector(selectAppInfo)
    const t = useSelector(selectTranslations)
    const isSaml = appInfo?.is_saml_login_enabled

    const normalizeUrl = (url) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return `${window.location.protocol}//${url}`
    }
    return url
}

    const getRedirectUrl = () => {
        // REACT_APP_WEB_URL (config/<brand>/.env.*): fixed web app address, wins over the tenant one
        if(process.env.REACT_APP_WEB_URL) return process.env.REACT_APP_WEB_URL
        if(appInfo?.personalizations?.tenant_settings?.url_webapp){
            return appInfo.personalizations.tenant_settings.url_webapp
        } else {
            return `${window.location.origin}` 
        }
    }


    const copyUrl = () => {
        const url = new URL(`${normalizeUrl(getRedirectUrl())}${WEB_PATH}/login/`);
        // SAML: the user logs in with the university credentials, the email is useless
        if(!isSaml) url.search = new URLSearchParams({ email: userInfo.email });
        navigator.clipboard.writeText(url);
        toast.success("Indirizzo copiato")
        setIsOpen(false)
    }

    return (
        <>
            {isMobile &&
                <div className="desktop_reminder" onClick={()=>setIsOpen(true)}>
                    <img src={computer_img} alt="" />
                </div>
            }
            {isMobile &&
                <Sheet isOpen={isOpen} onClose={()=>{setIsOpen(false)}} detent='content-height'>
                    <Sheet.Container>
                        <Sheet.Header />
                        <Sheet.Content className="text-center pb-3 px-3">
                            <img src={computer_pc_img} className="mx-auto mt-3" style={{width:'52px'}} alt=""/>
                            {isSaml ? <>
                                <TitleH2 className="mt-2">{t.login.saml_desktop_title}</TitleH2>
                                <Text className="mt-2">{t.login.saml_desktop_text.split('{url}').reduce((a, b) => <>{a}<i><u>{`${getRedirectUrl()}${WEB_PATH}`}</u></i>{b}</>)}</Text>
                            </> : <>
                                <TitleH2 className="mt-2">Accedi da computer con l’e-mail di iscrizione</TitleH2>
                                <Text className="mt-2">Utilizza l’e-mail <strong style={{color:'var(--primary-color)'}}>{userInfo.email}</strong> per accedere dal tuo computer.<br /> Collegati all’indirizzo <i><u>{`${getRedirectUrl()}${WEB_PATH}`}</u></i></Text>
                            </>}
                            <Button onClick={copyUrl} color="secondary" className="mb-5 mt-3 w-100 mx-auto">Copia l'indirizzo</Button>
                            {
                                ['development','testing'].includes(process.env.NODE_ENV) &&
                                <span className='mb-3'>
                                    App version: {process.env.REACT_APP_VERSION}
                                </span>
                            }
                        </Sheet.Content>
                    </Sheet.Container>
                        <Sheet.Backdrop onTap={()=>{setIsOpen(false)}}/>
                </Sheet>
            }
        </>
    )
}